import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useLayout } from "@/contexts/UseLayout";
import Player from "lottie-react";
import loadingAnimation from "@/assets/loading_screen.json";
import {
  hasAdLinkAccess,
  hasGoOnAccess,
  isRecruitingAndAdLinkOnly,
} from "@/components/utils/NiveisDeAcesso";

export function PrivateRoute() {
  const isAuthenticated = !!localStorage.getItem("token");
  const location = useLocation();
  const { userLogged, fullLoading } = useLayout();

  if (!isAuthenticated) {
    return <Navigate to="/login" />;
  }

  // Mostra loading enquanto os dados do usuário estão carregando
  if (fullLoading || !userLogged?.data?.id) {
    return (
      <div className="w-screen h-screen bg-azul-400 flex justify-center items-center">
        <Player
          autoplay
          loop
          animationData={loadingAnimation}
          style={{ height: "300px", width: "300px" }}
        />
      </div>
    );
  }

  const isAdLinkRoute = location.pathname.startsWith("/ad-link");
  const isRecruitingRoute =
    location.pathname.startsWith("/dash-recrutamento") ||
    location.pathname.startsWith("/criar-nova-vaga");

  // Usuário somente Ad Link tentando acessar rotas do GoOn
  if (
    !isAdLinkRoute &&
    hasAdLinkAccess(userLogged) &&
    !hasGoOnAccess(userLogged)
  ) {
    return <Navigate to="/ad-link" replace />;
  }

  if (
    !isAdLinkRoute &&
    !isRecruitingRoute &&
    isRecruitingAndAdLinkOnly(userLogged)
  ) {
    return <Navigate to="/dash-recrutamento" replace />;
  }

  return <Outlet />;
}
